export const gameConst = {
    onUpdateList: "onUpdateList",

}
